module.exports = __webpack_public_path__ + "img/Screenshot-9.d03f409c.png";